module.exports = __webpack_public_path__ + "img/news.f748531.svg";